import type { ActionHandler } from '../types'
import { GRADE_LEVELS } from '../types'

export const handleReceiveWound: ActionHandler<'RECEIVE_WOUND'> = async (ctx, payload) => {
  const row = {
    character_id: ctx.characterId,
    body_location: payload.body_location,
    laterality: payload.laterality,
    grade: payload.grade,
    injury_levels: GRADE_LEVELS[payload.grade] ?? 1,
    aspect: payload.aspect,
    effective_impact: payload.effective_impact,
    wound_type: payload.wound_type ?? null,
    is_bleeder: payload.grade.startsWith('G') || payload.grade.startsWith('K'),
  }

  const { data, error } = await ctx.supabase
    .from('character_injuries')
    .insert(row)
    .select()
    .single()

  if (error) throw error

  return {
    effects: [{
      character_id: ctx.characterId,
      target_table: 'character_injuries',
      target_row_id: data.id,
      target_field: '*',
      operation: 'INSERT' as const,
      old_value: null,
      new_value: data,
    }],
    label: `Wound: ${payload.grade} ${payload.aspect} to ${payload.body_location}`,
  }
}
